export default "__VITE_ASSET__DgOQk0E0__"